import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {NewsWidgetFetchHandler} from "./news-widget.fetch-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {NewsWidgetSeeMoreClickHandler} from "./news-widget.see-more-click.handler";
import {NewsWidgetArticleClickHandler} from "./news-widget.article-click.handler";
import {NewsWidgetArticleDisplayHandler} from "./news-widget.article-display-handler";
import {NewsWidgetDisplayHandler} from "./news-widget.display-handler";


export class NewsWidgetHandlers extends HandlerList {
  static injectables = [
    NewsWidgetFetchHandler,
    PopulateDataHandler,
    NewsWidgetSeeMoreClickHandler,
    NewsWidgetArticleClickHandler,
    NewsWidgetDisplayHandler,
    NewsWidgetArticleDisplayHandler
  ];

  constructor(
    newsWidgetFetchHandler: NewsWidgetFetchHandler,
    populateDataHandler: PopulateDataHandler,
    newsWidgetSeeMoreClickHandler: NewsWidgetSeeMoreClickHandler,
    newsWidgetArticleClickHandler: NewsWidgetArticleClickHandler,
    newsWidgetDisplayHandler: NewsWidgetDisplayHandler,
    newsWidgetArticleDisplayHandler: NewsWidgetArticleDisplayHandler
  ) {
    super();

    [
      newsWidgetFetchHandler,
      populateDataHandler,
      newsWidgetSeeMoreClickHandler,
      newsWidgetArticleClickHandler,
      newsWidgetDisplayHandler,
      newsWidgetArticleDisplayHandler
    ].forEach(handler => this.add(handler));
  }
}
